import { CompleteReasonTypeEnum } from 'app/models';

export class CompleteReasonTypeModel {
	public static CompleteReasonTypeList: Array<any> = [
		{ value: CompleteReasonTypeEnum.NoSignal, name: 'No Signal' },
		{ value: CompleteReasonTypeEnum.WrongPin, name: 'Wrong Pin' },
		{ value: CompleteReasonTypeEnum.GrayButtonCantSwipe, name: 'Gray Button Can\'t Swipe' },
		{ value: CompleteReasonTypeEnum.LowBattery, name: 'Low Battery' },
		{ value: CompleteReasonTypeEnum.Other, name: 'Other' }
	];
}
